module.exports = __webpack_public_path__ + "media/images/undraw_confirmed_sms-84879b774f3e410e13a899830603eada.png";